import React, { Component } from 'react';
import TimeSlotsTable from './TimeSlotsTable';
import TripsTable from './TripsTable';
import RtdTripsTable from './RtdTripsTable';
import { Radio } from 'antd';
import 'antd/dist/antd.css';
import { Row, Col, Checkbox, Input } from 'antd';
// import { ContextMenu, theme, animation } from 'react-contexify';
// import TripsTabRightClickMenu from './TripsTabRightClickMenu'
// import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const Search = Input.Search;
// const rightClickMenuThemeList = Object.keys(theme);
// const rightClickMenuAnimationList = Object.keys(animation);

class TripsTab extends Component {
    constructor() {
        super();
        this.state = {
            timeSlots: [],
            selectedRowKeys: []
        }
        this.onClustersTripsChange = this.onClustersTripsChange.bind(this);
        this.onPuDoChange = this.onPuDoChange.bind(this);
        this.updateRtdTripsTableSelectedRowKeys = this.updateRtdTripsTableSelectedRowKeys.bind(this);
        this.rtdtripstable = React.createRef();
    }

    onClustersTripsChange(e) {
        console.log(e);
        if (e.target.value === "rb_clusters") {
            this.props.updateTripsClustersRb("clusters");
        } else if (e.target.value === "rb_trips") {
            this.props.updateTripsClustersRb("trips");
        }
    }

    onPuDoChange(e) {
        console.log(e);
        if (e.target.value === "rb_pu") {
            this.props.updatePuDoRb("pu");
        } else if (e.target.value === "rb_do") {
            this.props.updatePuDoRb("do");
        } else if (e.target.value === "rb_pudo") {
            this.props.updatePuDoRb("pudo");
        }
    }

    componentWillMount() {
        this.initTimeSlots();
    }

    initTimeSlots() {
        this.state.timeSlots.push("Select All");
        let temp = 0, aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        for (var i = 0; i < 96; i++) {
            temp = i * 15;
            aHr = parseInt(temp / 60);
            aMin = temp - aHr * 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            this.state.timeSlots.push(aHrStr + aMinStr);
        }
    }

    findBest(ref) {
        console.log(ref);
    };

    updateSelectedTimeSlots = (theTimeSlots) => { this.props.updateSelectedTimeSlots(theTimeSlots) }
    updateSelectAllTimeSlots = (theSelectAllTimeSlots) => { this.props.updateSelectAllTimeSlots(theSelectAllTimeSlots) }
    updateTripsSelection = (theTrips) => { this.props.updateTripsSelection(theTrips) }

    updateRtdTripsTableSelectedRowKeys(theSelectedRowKeys){
        this.setState({ selectedRowKeys: theSelectedRowKeys });
    }

    render() {
        return (
            <div >
                <div id="trips">
                    {/* <div style={{ marginBottom: 8 }}>
                        <RadioGroup defaultValue="rb_trips" size="small" onChange={this.onClustersTripsChange}>
                            <RadioButton value="rb_clusters">Clusters</RadioButton>
                            <RadioButton value="rb_trips">Trips</RadioButton>
                        </RadioGroup>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                        <RadioGroup defaultValue="rb_pudo" size="small" onChange={this.onPuDoChange}>
                            <RadioButton value="rb_pu">Pick Up</RadioButton>
                            <RadioButton value="rb_do">Drop Off</RadioButton>
                            <RadioButton value="rb_pudo">Both</RadioButton>
                        </RadioGroup>
                    </div> */}
                    {/*<table id="newdes" style={{ fontSize: '14px', fontWeight: 'normal', borderCollapse: 'collapse', marginLeft: '6px' + 'em' }} border="0">
                        <tbody>
                            <tr style={{ backgroundColor: '#f3f3f3' }}>
                                <td><label style={{ font: '14px' }}><input id="clusters_radio" type="radio" />Clusters</label></td>
                                <td><label style={{ font: '14px' }}><input id="trips_radio" type="radio" />Trips</label></td>
                                <td></td>
                            </tr>
                            <tr style={{ backgroundColor: '#dcf1e9' }}>
                                <td style={{ border: '0px' }}><label style={{ font: '14px' }}><input id="pu_radio" type="radio" />Pick Up</label></td>
                                <td style={{ border: '0px' }}><label style={{ font: '14px' }}><input id="do_radio" type="radio" />Drop Off</label></td>
                                <td style={{ border: '0px' }}><label style={{ font: '14px' }}><input id="pudo_radio" type="radio" />Both</label></td>
                            </tr>
                            <tr style={{ backgroundColor: 'transparent' }}>
                                <td colSpan="3" style={{ border: '0px' }}><label style={{ marginLeft: '5px' + 'em', font: '16px', float: 'left', marginBottom: '10px' }}> </label></td>
                            </tr>
                        </tbody>
        </table>*/}
                    {/* <div style={{ display: 'block', width: '230px', height: '420px' }}>
                        <TimeSlotsTable timeSlots={this.state.timeSlots} 
                            updateSelectedTimeSlots={this.updateSelectedTimeSlots} updateSelectAllTimeSlots={this.updateSelectAllTimeSlots} />
                    </div> */}
                    {/*<Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                        <Col>
                            <Search
                                placeholder="input search text"
                                onSearch={value => console.log(value)}
                                enterButton
                                style={{ width: 150 }}
                            />
                        </Col>
                        <Col>
                            <Checkbox onChange={this.onCheckBoxChange}>Select All</Checkbox>
                        </Col>
                    </Row>*/}
                    <div style={{ display: 'block', width: 330, height: window.innerHeight - 342 }}>
                        {/* <TripsTable trips={this.props.trips} /> */}
                        <RtdTripsTable ref={this.rtdtripstable} trips={this.props.trips} updateTripsSelection={this.updateTripsSelection} 
                            userName={this.props.userName} selectedDate={this.props.selectedDate} GSENodeJsUrl={this.props.GSENodeJsUrl}
                            onReceiveFindBestResult={this.props.onReceiveFindBestResult} handleRefreshTrips={this.props.handleRefreshTrips}
                            updateRtdTripsTableSelectedRowKeys={this.updateRtdTripsTableSelectedRowKeys} selectedRowKeys={this.state.selectedRowKeys}/>
                    </div>
                    {/*<TripsTabRightClickMenu
                        theme={Object.keys(theme)[0]}
                        animation={Object.keys(animation)[0]}
                        findBest={this.findBest}
                        cancelClick={this.cancelClick}
                    />*/}
                </div>
            </div>
        )
    }
}

export default TripsTab;



// WEBPACK FOOTER //
// ./src/Componets/TripsTab.js